export default [
  {
    path: '/v2/class-operations',
    name: 'class-operation-v2',
    meta: { requiresAuth: true },
    component: () => import('./views/create-batch.vue')
  }
]
